import React from 'react'
import { Col, Row } from 'antd'
import './style.less'
import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'
import { translateToFormValues } from '../utils'

const PreviewScenarioTag = ({ qcPlanDetail }: { qcPlanDetail: AIQualityCheckPlanDetailItem | null }) => {
  const translatedData = translateToFormValues(qcPlanDetail)
  return (
    <div className="scheme-preview-scenario-tag-container">
      {translatedData?.nodeResults?.map((item, index) => (
        <div key={index}>
          <Row className="node-container">
            <Col span={2}>
              <h4 className="node-label">
                板块:
              </h4>
            </Col>
            <Col span={21}>
              <span className="node-value">{item.moduleName}</span>
            </Col>
          </Row>
          {item?.items?.map((subItem, subIndex) => (
            <Row key={subIndex} className="rule-container">
              <Col span={2}>
                <h4 className="node-label" style={{ marginTop: 6 }}>
                  标签{subIndex + 1}:
                </h4>
              </Col>
              <Col span={21}>
                <div className="rule-content">
                  <h4>
                    {subItem?.name}
                  </h4>
                  <div className="rule-content-description">
                    <span className="description-label">具体描述:</span>
                    <p>
                      {subItem?.description}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          ))}
        </div>
      ))}
    </div>
  )
}

export default PreviewScenarioTag
